!function(e){"undefined"==typeof module?this.charming=e:module.exports=e}(function(e,n){"use strict";n=n||{};var t=n.tagName||"span",o=null!=n.classPrefix?n.classPrefix:"char",r=1,a=function(e){for(var n=e.parentNode,a=e.nodeValue,c=a.length,l=-1;++l<c;){var d=document.createElement(t);o&&(d.className=o+r,r++),d.appendChild(document.createTextNode(a[l])),n.insertBefore(d,e)}n.removeChild(e)};return function c(e){for(var n=[].slice.call(e.childNodes),t=n.length,o=-1;++o<t;)c(n[o]);e.nodeType===Node.TEXT_NODE&&a(e)}(e),e});

// The Slideshow class.
class Slideshow {
  constructor(el) {
    this.DOM = {
      el: el
    };
    this.config = {
      slideshow: {
        delay: 3000,
        pagination: {
          duration: 3,
        }
      }
    };
    // Set the slideshow
    this.init();
  }
  init() {
    var self = this;
    // Charmed title
    this.DOM.slideTitle = this.DOM.el.querySelectorAll('.slide-title');
    this.DOM.slideTitle.forEach((slideTitle) => {
      charming(slideTitle);
    });
    // Set the slider
    var autoplay = {};
    if (this.DOM.el.dataset.autoplay == 'true') {
      autoplay = {
        delay: this.config.slideshow.delay,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      }
    } else {
      autoplay = false;
    }
    this.slideshow = new Swiper(this.DOM.el, {
      loop: false,
      autoplay: autoplay,
      speed: 1000,
      preloadImages: true,
      updateOnImagesReady: true,
      // lazy: true,
      // preloadImages: false,
      pagination: {
        el: '.swiper-slideshow-pagination',
        clickable: true,
        bulletClass: 'swiper-slideshow-pagination-item',
        bulletActiveClass: 'active',
        clickableClass: 'swiper-slideshow-pagination-clickable',
        modifierClass: 'swiper-slideshow-pagination-',
        renderBullet: function(index, className) {
          var slideIndex = index,
            number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);
          var paginationItem = '<span class="swiper-slideshow-pagination-item">';
          paginationItem += '<span class="pagination-number">' + number + '</span>';
          paginationItem = (index <= 8) ? paginationItem + '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' : paginationItem;
          paginationItem += '</span>';
          return paginationItem;
        },
      },
      // Navigation arrows
      navigation: {
        nextEl: '.slideshow-navigation-button.next',
        prevEl: '.slideshow-navigation-button.prev',
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      on: {
        init: function() {
          self.animate('next');
        },
      }
    });
    // Init/Bind events.
    this.initEvents();
    var VideoSlider = this.DOM.el;
    var slideshow = this.slideshow;
    if (this.DOM.el.dataset.autoplay == 'true') {
      VideoSlider.addEventListener('mouseenter', function(e) {
        slideshow.autoplay.stop();
      });
      VideoSlider.addEventListener('mouseleave', function(e) {
        slideshow.autoplay.start();
      });
    }
  }
  initEvents() {
    this.slideshow.on('paginationUpdate', (swiper, paginationEl) => this.animatePagination(swiper, paginationEl));
    //this.slideshow.on('paginationRender', (swiper, paginationEl) => this.animatePagination());
    this.slideshow.on('slideNextTransitionStart', () => this.animate('next'));
    this.slideshow.on('slidePrevTransitionStart', () => this.animate('prev'));
  }
  animate(direction = 'next') {
    // Get the active slide
    this.DOM.activeSlide = this.DOM.el.querySelector('.swiper-slide-active');

    if (this.DOM.activeSlide != null) {
      this.DOM.activeSlideImg = this.DOM.activeSlide.querySelector('.slide-image');
      this.DOM.activeSlideTitle = this.DOM.activeSlide.querySelector('.slide-title');
      this.DOM.activeSlideTitleLetters = this.DOM.activeSlideTitle.querySelectorAll('span');

      // Reverse if prev
      this.DOM.activeSlideTitleLetters = direction === "next" ? this.DOM.activeSlideTitleLetters : [].slice.call(this.DOM.activeSlideTitleLetters).reverse();
      // Get old slide
      this.DOM.oldSlide = direction === "next" ? this.DOM.el.querySelector('.swiper-slide-prev') : this.DOM.el.querySelector('.swiper-slide-next');
      if (this.DOM.oldSlide) {
        // Get parts
        this.DOM.oldSlideTitle = this.DOM.oldSlide.querySelector('.slide-title'),
          this.DOM.oldSlideTitleLetters = this.DOM.oldSlideTitle.querySelectorAll('span');
        // Animate
        this.DOM.oldSlideTitleLetters.forEach((letter, pos) => {
          TweenMax.to(letter, .3, {
            ease: Quart.easeIn,
            delay: (this.DOM.oldSlideTitleLetters.length - pos - 1) * .04,
            y: '50%',
            opacity: 0
          });
        });
      }
      // Animate title
      this.DOM.activeSlideTitleLetters.forEach((letter, pos) => {
        TweenMax.to(letter, .6, {
          ease: Back.easeOut,
          delay: pos * .05,
          startAt: {
            y: '50%',
            opacity: 0
          },
          y: '0%',
          opacity: 1
        });
      });
      // Animate background
      TweenMax.to(this.DOM.activeSlideImg, 1.5, {
        ease: Expo.easeOut,
        startAt: {
          x: direction === 'next' ? 200 : -200
        },
        x: 0,
      });
    }
    //this.animatePagination()
  }
  animatePagination(swiper, paginationEl) {
    // Animate pagination
    this.DOM.paginationItemsLoader = paginationEl.querySelectorAll('.pagination-separator-loader');
    this.DOM.activePaginationItem = paginationEl.querySelector('.swiper-slideshow-pagination-item.active');
    this.DOM.activePaginationItemLoader = this.DOM.activePaginationItem.querySelector('.pagination-separator-loader');
    console.log('swiper', swiper);
    console.log('swiper.activeIndex', swiper.activeIndex);
    videoControls(swiper.activeIndex);
    // Reset and animate
    TweenMax.set(this.DOM.paginationItemsLoader, {
      scaleX: 0
    });
    TweenMax.to(this.DOM.activePaginationItemLoader, this.config.slideshow.pagination.duration, {
      startAt: {
        scaleX: 0
      },
      scaleX: 1,
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  videoSliderAndControls();
});
document.addEventListener("shopify:section:load", function() {
  videoSliderAndControls();
});
document.addEventListener("shopify:section:unload", function() {
  videoSliderAndControls();
});
document.addEventListener("shopify:section:reorder", function() {
  videoSliderAndControls();
});
//const slideshow = new Slideshow(document.querySelector('.video-slideshow'));
function videoSliderAndControls() {
  //create slideshow
  var allVideoSliders = document.querySelectorAll('.video-slideshow');
  if (allVideoSliders != null) {
    allVideoSliders.forEach(function(VideoSlider) {
      var slideshow = new Slideshow(VideoSlider);
      // controlls hover effect
      var v = VideoSlider;
      var slideControls = VideoSlider.querySelectorAll('.video-slide-pause-button,.video-slideshow .slideshow-navigation');
      if (slideControls != null && v != null && window.innerWidth > 1023) {
        v.addEventListener('mouseover', function(e) {
          slideControls.forEach(function(c) {
            c.style.display = 'flex';
          });
        });
        v.addEventListener('mouseout', function(e) {
          slideControls.forEach(function(c) {
            c.style.display = 'none';
          });
        });
      }
    });
  }
  videoControls(null);

  // if there is only one slide and autoplay true
  var allVideoSliders = document.querySelectorAll('.video-slideshow');
    allVideoSliders.forEach(function(slider){
        var videoSlides = slider.querySelectorAll('.full-width-video-slide');
        var autoplay = slider.dataset.autoplay;
        var audio = slider.dataset.audio;
         if(autoplay == 'true' && videoSlides.length == 1 && audio == 'false'){
             videoSlides.forEach(function(slide, i) {
                if (slide.querySelector('video') != null) {
                  slide.querySelector('video').play();
                }
                if (slide.querySelector('iframe') != null) {
                  var slideIframePoster = slide.querySelector('.iframe-poster-image');
                  var iframe = slide.querySelector('iframe');
                  var iframeSrc = iframe.src;
                  iframe.src = iframeSrc.replace("autoplay=0", "autoplay=1");
                }
             //
             var slideControls = slide.querySelectorAll('.video-slide-pause-button a');
              if (slideControls != null ) {
                slideControls.forEach(function(control) {
                  if (control.classList.contains('video-play')) {
                    control.style.display = 'none';
                  } else {
                    control.style.display = 'block';
                  }
                });
              }
            //
            });
         }
      });
}

function videoControls(activeIndex) {
  // video controlls
  var videoSlides = document.querySelectorAll('.full-width-video-slide');
  if (videoSlides != null) {
    videoSlides.forEach(function(slide, i) {
      var slideIndex = slide.dataset.index;
      videoSlides.forEach(function(slide, i) {
        var slideIndex = slide.dataset.index;
        if (slide.querySelector('video') != null) {
          slide.querySelector('video').pause();
        }
        if (slide.querySelector('iframe') != null) {
          var slideIframePoster = slide.querySelector('.iframe-poster-image');
          var iframe = slide.querySelector('iframe');
          var iframeSrc = iframe.src;
          iframe.src = iframeSrc.replace("autoplay=1", "autoplay=0");
          if (slideIframePoster != null) slideIframePoster.style.display = 'block';
        }
      });
      if (slide != null) {
        var slideVideo = slide.querySelector('video');
        var slideIframe = slide.querySelector('iframe');
        var slideIframePoster = slide.querySelector('.iframe-poster-image');
        var slideControls = slide.querySelectorAll('.video-slide-pause-button a');

        //  audio buttons
        var slideAudioControls = slide.querySelectorAll('.video-slide-audio-button a');
         if(slideAudioControls.length > 0){
          slideAudioControls.forEach(function(control) {
            if (control.classList.contains('audio-pause')) {
              control.style.display = 'none';
            } else {
              control.style.display = 'flex';
            }
            //
            control.onclick = function(e) {
              e.preventDefault();
              if (control.classList.contains('audio-pause')) {
                control.style.display = 'none';
                control.closest('.video-slide-audio-button').querySelector('.audio-play').style.display = 'flex';
                if (slideVideo != null) {
                  slideVideo.muted = true;
                }
              } else {
                control.style.display = 'none';
                control.closest('.video-slide-audio-button').querySelector('.audio-pause').style.display = 'flex';
                if (slideVideo != null) {
                  slideVideo.muted = false;
                }
              }
            }
            //
          });
         }
        //

        if (slideControls != null) {
          slideControls.forEach(function(control) {
            if (Shopify.designMode == true) control.closest('.video-slide-pause-button').style.display = 'flex';
            if (control.closest('.iframe-video-slide') != null) control.closest('.slide-image').classList.remove('iframe-video-slide-played');
            if (control.classList.contains('video-pause')) {
              control.style.display = 'none';
            } else {
              control.style.display = 'block';
            }
            control.onclick = function(e) {
              e.preventDefault();
              if (control.classList.contains('video-pause')) {
                control.style.display = 'none';
                control.closest('.video-slide-pause-button').querySelector('.video-play').style.display = 'block';
                if (slideVideo != null) {
                  slideVideo.pause();
                }
                if (slideIframe != null) {
                  var iframeSrc = slideIframe.src;
                  if (Shopify.designMode == undefined) slideIframe.src = iframeSrc.replace("autoplay=1", "autoplay=0");
                  control.closest('.video-slide-pause-button').style.display = 'none';
                  if (control.closest('.iframe-video-slide') != null) control.closest('.slide-image').classList.remove('iframe-video-slide-played');
                  if (slideIframePoster != null) slideIframePoster.style.display = 'block';
                }
              } else {
                control.style.display = 'none';
                control.closest('.video-slide-pause-button').querySelector('.video-pause').style.display = 'block';
                if (slideVideo != null) {
                  slideVideo.play();
                }
                if (slideIframe != null) {
                  var iframeSrc = slideIframe.src;
                  if (Shopify.designMode == undefined) slideIframe.src = iframeSrc.replace("autoplay=0", "autoplay=1");
                  control.closest('.video-slide-pause-button').style.display = 'none';
                  if (control.closest('.iframe-video-slide') != null) control.closest('.slide-image').classList.add('iframe-video-slide-played');
                  if (slideIframePoster != null) slideIframePoster.style.display = 'none';
                }
              }
            }
          });
        }
      }
    });
  }
}
